import type { Dictionary } from "../i18n";

const dictionary: Dictionary = {
  "success.pendingTitle": "Deine Bestellung wird noch bestätigt",
  "success.pendingBody": "Die Zahlungsbestätigung dauert länger als üblich. Bitte zahle nicht erneut. Du kannst erneut prüfen, zu deiner Bestellung zurückkehren oder den Support mit der unten stehenden Bestellnummer kontaktieren.",
  "success.cancelledTitle": "Diese Bestellung wurde storniert",
  "success.cancelledBody": "Wurde deine Karte belastet oder ein Betrag reserviert, wird das Geld zurückgegeben. Du musst nichts weiter tun.",
  "success.checkAgain": "Erneut prüfen",

  "error.countryClosed": "In diesem Land sind keine neuen Bestellungen oder Zahlungen für unbezahlte Bestellungen mehr möglich. Bezahlte Bestellungen und der Support werden weiter bearbeitet.",
  "error.providerCountryClosed": "Deine Bestellung kann vom zugewiesenen Anbieter nicht mehr ausgeführt werden. Starte eine neue Bestellung, dann vermitteln wir dich erneut.",
  "chrome.reviewTitle": "Prüfen und bezahlen",
  "chrome.paidTitle": "Bestellbestätigung",
  "chrome.paymentTitle": "Zahlung",
  "chrome.language": "Sprache",
  "chrome.close": "Schließen",
  "chrome.logoAlt": "Tinkr",
  "common.loading": "Wird geladen",
  "common.error": "Etwas ist schiefgelaufen.",
  "common.retry": "Erneut versuchen",
  "common.labelSeparator": ": ",
  "trust.badge": "Verkauft von Tinkr · Hergestellt von einem zugelassenen lokalen Druckpartner",
  "review.orderSummary": "Bestellübersicht",
  "review.threeD": "3D",
  "review.specsQty": "Anzahl",
  "review.delivery.title": "Lieferung",
  "review.shipping.title": "Versandangaben",
  "review.shipping.edit": "Bearbeiten",
  "review.payment.title": "Zahlungsmethode",
  "review.payment.card": "Kredit- oder Debitkarte",
  "review.payment.cardHint": "Visa, Mastercard und weitere",
  "review.payment.usdc": "USDC-Stablecoin",
  "review.payment.comingSoon": "Demnächst verfügbar",
  "review.price.title": "Preis",
  "review.price.itemSubtotal": "Zwischensumme",
  "review.price.premium": "Premium-Fertigung",
  "review.price.shipping": "Versand",
  "review.price.shippingIncluded": "Inbegriffen",
  "review.price.total": "Gesamtsumme",
  "review.price.taxNote": "Tinkr erhebt für diese Bestellung keine Transaktionssteuer.",
  "review.price.updating": "Gesamtsumme wird aktualisiert…",
  "review.price.refreshError": "Die Gesamtsumme konnte nicht aktualisiert werden. Lade die Seite vor dem Bezahlen neu.",
  "review.price.multicolor": "Mehrfarbig",
  "review.price.multicolorCapNote": "Wir konnten diese Figur nicht genau vermessen, daher gilt der maximale Mehrfarbenpreis.",
  "review.pricing.calculating": "Ihr genauer Preis wird berechnet…",
  "review.pricing.calculatingBody": "Der Preis Ihrer mehrfarbigen Figur wird aus ihrem eigenen Druck berechnet. Das dauert meist weniger als eine Minute.",
  "review.pricing.from": "Ab",
  "review.pricing.stillWorking": "Wir arbeiten noch daran. Danke für Ihre Geduld.",
  "review.pricing.timeout": "Wir konnten Ihren Preis nicht fertig berechnen. Bitte versuchen Sie es erneut.",
  "review.consent.prefix": "Mit dem Setzen dieses Häkchens stimmst du den",
  "review.consent.terms": "Nutzungsbedingungen",
  "review.consent.and": "und der",
  "review.consent.privacy": "Datenschutzerklärung von Tinkr zu",
  "review.cta.pay": "Bezahlen",
  "review.cta.secure": "Sicher bezahlen",
  "coupon.toggle": "Hast du einen Gutscheincode?",
  "coupon.label": "Gutscheincode",
  "coupon.placeholder": "Code eingeben",
  "coupon.apply": "Einlösen",
  "coupon.applying": "Wird eingelöst…",
  "coupon.remove": "Entfernen",
  "coupon.removing": "Wird entfernt…",
  "coupon.appliedLabel": "Gutschein",
  "coupon.error.notFound": "Dieser Gutscheincode wurde nicht gefunden",
  "coupon.error.expired": "Dieser Gutschein ist abgelaufen",
  "coupon.error.revoked": "Dieser Gutschein ist nicht mehr gültig",
  "coupon.error.notStarted": "Dieser Gutschein ist noch nicht aktiv",
  "coupon.error.notApplicable": "Dieser Gutschein kann für diese Bestellung nicht verwendet werden",
  "coupon.error.usageLimit": "Das Nutzungslimit dieses Gutscheins ist erreicht",
  "coupon.error.alreadyApplied": "Dieser Gutschein wurde bereits eingelöst",
  "coupon.error.retry": "Warte einen Moment und versuche es erneut",
  "coupon.error.generic": "Dieser Code kann nicht verwendet werden",
  "redirect.title": "Du wirst zur sicheren Zahlung weitergeleitet…",
  "redirect.subtitle": "Weiterleitung zur sicheren Zahlungsseite von Stripe.",
  "redirect.badgeVerified": "Verifiziert",
  "redirect.badgeEncrypted": "Verschlüsselt",
  "redirect.badgeSsl": "SSL-gesicherte Verbindung",
  "success.title": "Zahlung abgeschlossen!",
  "success.authorizedTitle": "Bestellung bestätigt!",
  "success.orderNumber": "Bestellnummer",
  "success.paidTotal": "Bezahlter Betrag",
  "success.authorizedTotal": "Vorübergehende Kartenreservierung",
  "success.nextTitle": "So geht es weiter",
  "success.step1": "Dein Druckpartner wird benachrichtigt",
  "success.step2": "Er druckt und prüft die Qualität",
  "success.step3": "Die Bestellung wird an dich versandt",
  "success.statusCompleted": "Abgeschlossen",
  "success.statusPending": "In Bearbeitung",
  "success.statusUpcoming": "Als Nächstes",
  "success.track": "Bestellung verfolgen",
  "success.viewOrder": "Bestellung ansehen →",
  "success.back": "Zurück zu Tinkr",
  "success.returnToDoodles": "Zurück zu Tinkr Doodles",
  "success.returnToSite": "Zurück zu deiner Bestellung",
  "success.confirming": "Bestellung wird bestätigt…",
  "success.notConfirmed": "Deine Bestellung konnte noch nicht bestätigt werden. Prüfe sie in einigen Minuten erneut.",
  "cancelled.title": "Du hast die Zahlungsseite verlassen",
  "cancelled.body": "Deine Bestellung ist gespeichert. Es kann einen Moment dauern, bis der Zahlungsstatus aktualisiert wird.",
  "cancelled.orderRef": "Bestellnummer",
  "cancelled.tip": "Prüfe deine Verbindung oder die Freigabe durch deine Bank und versuche es erneut.",
  "cancelled.retry": "Erneut versuchen",
  "cancelled.help": "Hilfe",
  "footer.terms": "Nutzungsbedingungen",
  "footer.privacy": "Datenschutz",
  "footer.refund": "Erstattungen und Stornierungen",
  "footer.seller": "Verkäuferinformationen",
  "footer.tokushoho": "Hinweis nach dem Gesetz über bestimmte Handelsgeschäfte",
  "footer.entity": "Tinkr App Ltd",
  "footer.companyNo": "Firmennr.",
  "legal.back": "Zurück",
  "legal.updated": "Zuletzt aktualisiert",
  "error.notFound": "Dieser Zahlungslink wurde nicht gefunden. Prüfe den Link in deiner E-Mail.",
  "error.expired": "Dieser Zahlungslink ist abgelaufen.",
  "error.alreadyPaid": "Diese Bestellung wurde bereits bezahlt.",
  "error.payFailed": "Die Zahlung konnte nicht gestartet werden. Versuche es erneut.",
  "error.couponNoLongerValid": "Der Gutschein für diese Bestellung ist nicht mehr gültig. Entferne ihn und versuche es erneut.",
  "error.couponLimitReached": "Das Nutzungslimit dieses Gutscheins ist derzeit erreicht. Entferne ihn, um fortzufahren, oder versuche es später erneut.",
  "error.couponNotApplicable": "Dieser Gutschein gilt nicht für diesen Bestellbetrag. Entferne ihn und versuche es erneut.",
  "error.paymentConfirming": "Deine Zahlung wird bereits bestätigt. Warte einen Moment und lade diese Seite dann neu.",
  "error.sessionConflict": "Der Checkout wurde in einem anderen Fenster geändert. Bitte versuche es erneut.",
  "error.recoveryHint": "Öffne die neueste E-Mail zu deiner Bestellung, um einen neuen Zahlungslink zu erhalten, oder wende dich an den Support.",
  "error.backToSite": "Zurück zur Website"
};

export default dictionary;
